import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { InformationComponent } from '../../core/information/information.component';
var DownloadLogComponent = (function () {
    function DownloadLogComponent(apiService, activeModal, modalService, translateService) {
        this.apiService = apiService;
        this.activeModal = activeModal;
        this.modalService = modalService;
        this.translateService = translateService;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.loading = false;
        this.tableData = [];
    }
    DownloadLogComponent.prototype.ngOnInit = function () {
        this.loadCeleryResults();
    };
    DownloadLogComponent.prototype.loadCeleryResults = function (resetPageNumber) {
        var _this = this;
        if (resetPageNumber === void 0) { resetPageNumber = true; }
        if (!this.feature) {
            return;
        }
        if (resetPageNumber) {
            this.currentPage = 1;
        }
        this.loading = true;
        var params = {
            page: this.currentPage,
            feature: this.feature,
            page_size: this.itemsPerPage,
        };
        this.apiService.getCeleryResults(params).subscribe(function (response) {
            _this.loading = false;
            _this.tableData = response.results;
            _this.totalItems = response.count;
        }, function (error) {
            _this.loading = false;
            _this.totalItems = undefined;
        });
    };
    DownloadLogComponent.prototype.pageChanged = function () {
        this.loadCeleryResults(false);
    };
    DownloadLogComponent.prototype.optionChanged = function () {
        this.loadCeleryResults();
    };
    DownloadLogComponent.prototype.downloadFile = function (data) {
        var _this = this;
        this.apiService.getFileFullPath(data.file_path, { need_decrypt: false }).subscribe(function (blob) {
            _this.apiService.createDownloadFile(blob, data.filename);
        });
    };
    DownloadLogComponent.prototype.openConfirmModal = function (content, data, action) {
        var _this = this;
        this.message = action === 'cancel'
            ? this.translateService.instant('DOWNLOAD-LOGS.CONFIRM-CANCEL')
            : this.translateService.instant('DOWNLOAD-LOGS.CONFIRM-DELETE');
        this.modal = this.modalService.open(content, { centered: true });
        this.modal.result.then(function (result) {
            if (!result) {
                return;
            }
            var request$ = action === 'cancel'
                ? _this.apiService.revokeCeleryTask(data.id)
                : _this.apiService.deleteCeleryTask(data.id);
            request$.subscribe(function () {
                _this.informUser(action === 'cancel'
                    ? _this.translateService.instant('DOWNLOAD-LOGS.SUCCESSFULLY-CANCELLED')
                    : _this.translateService.instant('DOWNLOAD-LOGS.SUCCESSFULLY-DELETED'));
                _this.loadCeleryResults();
            }, function (err) { _this.informUser(); });
        });
    };
    DownloadLogComponent.prototype.informUser = function (message) {
        var informModal = this.modalService.open(InformationComponent, { centered: true });
        informModal.componentInstance.message = message || this.translateService.instant('ERROR.TRY-AGAIN');
    };
    return DownloadLogComponent;
}());
export { DownloadLogComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/download-log/download-log.component.ts.pre-build-optimizer.js